import type { FC } from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Card,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { numberToMillons } from 'src/utils/functions';
import Panel from '../../../components/global/Panel';
import PanelHeader from '../../../components/global/PanelHeader';
import PanelTitle from '../../../components/global/PanelTitle';
import PanelFilter from '../../../components/admin/PanelFilter';
import Scrollbar from '../../../components/admin/Scrollbar';
import TableCellHeaderBasic from '../../../components/global/TableCellHeaderBasic';
import Title from '../../../components/admin/Title';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import { onGet } from '../../../store/actions/global';
import TableCellHeaderSum from '../../../components/global/TableCellHeaderSum';
import CurvaProduccionChartLine from '../curva-produccion/CurvaProduccionChartLine';
import CurvaProduccionChartBarLine from '../curva-produccion/CurvaProduccionChartBarLine';

const AvanceAcumulado: FC<any> = ({ onGet: onGetExec }) => {
  const isMountedRef = useIsMountedRef();
  const defaultLimit = 10;
  const title = 'Avance Acumulado – META BUDGET';
  const [headersCurve, setHeadersCurve] = useState([]);
  const [dataCurve, setDataCurve] = useState({ peso: [], pesoA: [], fcst: [], fcstA: [], real: [], realA: [], ing: [], ingA: [], fcstIngreso: [], fcstIngresoA: [], realIngreso: [], realIngresoA: [], caida: [], caidaA: [], avance: [], cantDesembolso: [], cantAccDesembolso: [] });
  const [jfn, setJfn] = useState({
    data: [],
    resume: {
      operaciones: 0,
      facturacion: 0,
      operacionesMejorMes: 0,
      facturacionMejorMes: 0,
      operacionesAntMes: 0,
      meta: 0,
      desfase: 0,
      desfasePorc: 0,
      avance: 0,
    },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [relation, setRelation] = useState({
    data: [],
    resume: {
      operaciones: 0,
      facturacion: 0,
      operacionesMejorMes: 0,
      facturacionMejorMes: 0,
      operacionesAntMes: 0,
      meta: 0,
      desfase: 0,
      desfasePorc: 0,
      avance: 0,
    },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [valuesFilter, setValuesFilter] = useState({
    year: null,
    month: null,
    bestMonth: 0,
    bestYearMonthDayEnd: '',
  });

  const headers = [
    '',
    'Operaciones',
    'Facturación',
    'Operaciones ',
    'Facturación ',
    'Monto',
    'Var.',
    'Op.Meta',
    'Facturación  ',
    '',
    'Acumulado',
  ];

  const headersFuvex = [
    'EQUIPO',
    'Operaciones',
    'Facturación ',
    'Operaciones ',
    'Facturación  ',
    'Monto',
    'Var.',
    'Op.Meta',
    'Facturación  ',
    'Acumulado',
  ];

  const onSubmit = async (values) => {
    if (isMountedRef.current) {
      setValuesFilter(values);
      const response = await onGetExec({
        url: '/dashboard/avance-acumulado',
        body: { ...values, limit: defaultLimit },
      });
      const bestMonth = response?.header?.bestMonth || 0;
      const bestYearMonthDayEnd = response?.header?.bestYearMonthDayEnd || '';
      setValuesFilter((item) => ({
        ...item,
        bestMonth,
        bestYearMonthDayEnd,
      }));
      setJfn(response?.jfn);
      setRelation(response?.relation);
      setDataCurve(response?.dataCurve?.data);
      setHeadersCurve(response?.dataCurve?.headers);
    }
  };

  const handleChangePage = async (event: unknown, page: number) => {
    const { year, month, bestMonth, bestYearMonthDayEnd } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/avance-acumulado/detail',
      body: {
        year,
        month,
        bestMonth,
        bestMonthDay: bestYearMonthDayEnd,
        limit: Number(jfn.pages.limit),
        page,
        type: 'JFN',
      },
    });
    setJfn(response);
  };

  const handleChangeRowsPerPage = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month, bestMonth, bestYearMonthDayEnd } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/avance-acumulado/detail',
      body: {
        year,
        month,
        bestMonth,
        bestMonthDay: bestYearMonthDayEnd,
        limit: Number(event.target.value),
        page: 0,
        type: 'JFN',
      },
    });
    setJfn(response);
  };

  const handleChangePageJFR = async (event: unknown, page: number) => {
    const { year, month, bestMonth, bestYearMonthDayEnd } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/avance-acumulado/detail',
      body: {
        year,
        month,
        bestMonth,
        bestMonthDay: bestYearMonthDayEnd,
        limit: Number(relation.pages.limit),
        page,
        type: 'JFR',
      },
    });
    setRelation(response);
  };

  const handleChangeRowsPerPageJFR = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month, bestMonth, bestYearMonthDayEnd } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/avance-acumulado/detail',
      body: {
        year,
        month,
        bestMonth,
        bestMonthDay: bestYearMonthDayEnd,
        limit: Number(event.target.value),
        page: 0,
        type: 'JFR',
      },
    });
    setRelation(response);
  };

  return (
    <>
      <Helmet>
        <title>
          Dashboard:
          {title}
        </title>
      </Helmet>
      <Panel>
        <PanelHeader>
          <PanelTitle
            title={title}
            subTitlePrim="Dashboard"
            subTitleSec={title}
          />
        </PanelHeader>
        <PanelFilter onSubmit={onSubmit} yearMonth />
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} mt={2}>
            <CurvaProduccionChartLine data={dataCurve} headers={headersCurve} title="Real Acum. Vs Fcst Acum." />
          </Grid>
          <Grid item xs={12} md={6} mt={2}>
            <CurvaProduccionChartBarLine data={dataCurve} headers={headersCurve} title="Desembolsos: #Operaciones" />
          </Grid>
          <Grid item xs={12}>
            <Title title="Jefas de Negocio" />
            <Card>
              <Scrollbar>
                <Table size="small" className="zoomin">
                  <TableHead>
                    <TableRow>
                      <TableCellHeaderBasic
                        width="250px"
                        style={{ background: '#043263', border: 0 }}
                      >
                        EQUIPO JEFE DE NEGOCIO
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        colSpan={2}
                        align="center"
                        style={{ background: '#043263', border: 0 }}
                      >
                        MES ACTUAL
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        colSpan={2}
                        align="center"
                        style={{ background: '#7b7b7b', border: 0 }}
                      >
                        MEJOR MES
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        colSpan={2}
                        align="center"
                        style={{ background: '#043263', border: 0 }}
                      >
                        DESFASE
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        colSpan={2}
                        align="center"
                        style={{ background: '#7b7b7b', border: 0 }}
                      >
                        META
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        width="100px"
                        style={{ background: '#5ac4c4', border: 0 }}
                      >
                        Dispersión
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        width="100px"
                        style={{ background: '#5ac4c4', border: 0 }}
                      >
                        % Avance
                      </TableCellHeaderBasic>
                    </TableRow>
                    <TableRow>
                      {headers.map((header, index) => {
                        const key = `h1_${index}`;
                        let bgColor = '#bfbfbf';
                        let align:
                        | 'inherit'
                        | 'left'
                        | 'center'
                        | 'right'
                        | 'justify' = 'left';
                        if (index === 0) bgColor = '#043263';
                        if (index === 9 || index === 10) bgColor = '#5ac4c4';
                        if (index !== 0) {
                          align = 'center';
                        }
                        const color = index === 0 || index === 9 || index === 10 ? 'white' : '#043263';
                        return (
                          <TableCellHeaderBasic
                            key={key}
                            style={{ background: bgColor, color }}
                            align={align}
                          >
                            {header}
                          </TableCellHeaderBasic>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {jfn.data.map((item) => (
                      <TableRow key={item.jfn}>
                        <TableCell>{item.jfn}</TableCell>
                        <TableCell align="center">{item.operaciones}</TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.facturacion)}
                        </TableCell>
                        <TableCell align="center">
                          {item.operacionesMejorMes}
                        </TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.facturacionMejorMes)}
                        </TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.desfase)}
                        </TableCell>
                        <TableCell align="center">
                          {item.desfasePorc}
                          %
                        </TableCell>
                        <TableCell align="center">
                          {item.operacionesAntMes}
                        </TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.meta)}
                        </TableCell>
                        <TableCell align="center">
                          {item.dispersion}
                          %
                        </TableCell>
                        <TableCell align="center">
                          {item.avance}
                          %
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableHead>
                    <TableRow>
                      <TableCellHeaderSum>Total</TableCellHeaderSum>
                      <TableCellHeaderSum align="center">
                        {jfn.resume.operaciones}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(jfn.resume.facturacion)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="center">
                        {jfn.resume.operacionesMejorMes}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(jfn.resume.facturacionMejorMes)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(jfn.resume.desfase)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="center">
                        {jfn.resume.desfasePorc}
                        %
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="center">
                        {jfn.resume.operacionesAntMes}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(jfn.resume.meta)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="center" />
                      <TableCellHeaderSum align="center">
                        {jfn.resume.avance}
                        %
                      </TableCellHeaderSum>
                    </TableRow>
                  </TableHead>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 15, 20]}
                        labelRowsPerPage="Registros por página"
                        labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                        count={jfn.pages.total}
                        page={jfn.pages.current}
                        rowsPerPage={jfn.pages.limit}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </Scrollbar>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Title title="Jefas de Relación" />
            <Card>
              <Scrollbar>
                <Table size="small" className="zoomin">
                  <TableHead>
                    <TableRow>
                      <TableCellHeaderBasic
                        width="250px"
                        style={{ background: '#043263', border: 0 }}
                      />
                      <TableCellHeaderBasic
                        colSpan={2}
                        align="center"
                        style={{ background: '#043263', border: 0 }}
                      >
                        MES ACTUAL
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        colSpan={2}
                        align="center"
                        style={{ background: '#7b7b7b', border: 0 }}
                      >
                        MEJOR MES
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        colSpan={2}
                        align="center"
                        style={{ background: '#043263', border: 0 }}
                      >
                        DESFASE
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        colSpan={2}
                        align="center"
                        style={{ background: '#7b7b7b', border: 0 }}
                      >
                        META
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        width="100px"
                        style={{ background: '#5ac4c4', border: 0 }}
                      >
                        % Avance
                      </TableCellHeaderBasic>
                    </TableRow>
                    <TableRow>
                      {headersFuvex.map((header, index) => {
                        const key = `h2_${index}`;
                        let bgColor = '#bfbfbf';
                        let align:
                        | 'inherit'
                        | 'left'
                        | 'center'
                        | 'right'
                        | 'justify' = 'left';
                        if (index === 0) bgColor = '#043263';
                        if (index === 9) bgColor = '#5ac4c4';
                        if (index !== 0) {
                          align = 'center';
                        }
                        const color = index === 0 || index === 9 ? 'white' : '#043263';
                        return (
                          <TableCellHeaderBasic
                            key={key}
                            style={{ background: bgColor, color }}
                            align={align}
                          >
                            {header}
                          </TableCellHeaderBasic>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {relation.data.map((item) => (
                      <TableRow key={item.jfr}>
                        <TableCell>{item.jfr}</TableCell>
                        <TableCell align="center">{item.operaciones}</TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.facturacion)}
                        </TableCell>
                        <TableCell align="center">
                          {item.operacionesMejorMes}
                        </TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.facturacionMejorMes)}
                        </TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.desfase)}
                        </TableCell>
                        <TableCell align="center">
                          {item.desfasePorc}
                          %
                        </TableCell>
                        <TableCell align="center">
                          {item.operacionesAntMes}
                        </TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.meta)}
                        </TableCell>
                        <TableCell align="center">
                          {item.avance}
                          %
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableHead>
                    <TableRow>
                      <TableCellHeaderSum>Total</TableCellHeaderSum>
                      <TableCellHeaderSum align="center">
                        {relation.resume.operaciones}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(relation.resume.facturacion)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="center">
                        {relation.resume.operacionesMejorMes}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(relation.resume.facturacionMejorMes)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(relation.resume.desfase)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="center">
                        {relation.resume.desfasePorc}
                        %
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="center">
                        {relation.resume.operacionesAntMes}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(relation.resume.meta)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="center">
                        {relation.resume.avance}
                        %
                      </TableCellHeaderSum>
                    </TableRow>
                  </TableHead>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 15, 20]}
                        labelRowsPerPage="Registros por página"
                        labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                        count={relation.pages.total}
                        page={relation.pages.current}
                        rowsPerPage={relation.pages.limit}
                        onPageChange={handleChangePageJFR}
                        onRowsPerPageChange={handleChangeRowsPerPageJFR}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </Scrollbar>
            </Card>
          </Grid>
        </Grid>
      </Panel>
    </>
  );
};

export default connect(null, {
  onGet,
})(AvanceAcumulado);
